// Version: 1.2
// v1.2: Buttons use the shared button system (CV-49): 8px corners, standard variants and sizes, one selected look; no inline radius, padding or font size.
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth, authFetch } from './auth';
import './Login.css';

export default function ChangePassword() {
  const { user, clearPasswordChangeRequired } = useAuth();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm]   = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const [done, setDone]         = useState(false);
  const [policy, setPolicy]     = useState(null);

  useEffect(() => {
    authFetch('/api/config/password-policy')
      .then(r => r.json())
      .then(d => setPolicy(d))
      .catch(() => {});
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setError('Passwords do not match'); return; }
    setLoading(true); setError('');
    try {
      const res = await authFetch('/api/auth/change-password', {
        method: 'POST',
        body: JSON.stringify({ password })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Failed to update password');
      setLoading(false);
      setDone(true);
      clearPasswordChangeRequired();
      setTimeout(() => {
        const stored = JSON.parse(localStorage.getItem('stg_user') || '{}');
        if (stored.role === 'client' && stored.client_slug) {
          navigate('/clients/' + stored.client_slug);
        } else {
          navigate('/dashboard');
        }
      }, 1500);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // If no user in context yet, show loading state
  if (!user) {
    return (
      <div className="login-wrap">
        <div className="login-card">
          <div className="login-header">
            <div className="login-logo">
              <span className="login-logo-stg">STG</span>
              <span className="login-logo-sep" />
              <span className="login-logo-sub">Assessment Portal</span>
            </div>
          </div>
          <div className="login-body" style={{textAlign:'center',padding:'32px 0'}}>
            <span className="spinner" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-wrap">
      <div className="login-card">
        <div className="login-header">
          <div className="login-logo">
            <span className="login-logo-stg">STG</span>
            <span className="login-logo-sep" />
            <span className="login-logo-sub">Assessment Portal</span>
          </div>
          <div className="login-tagline">Set your new password</div>
        </div>
        <div className="login-body">
          {done ? (
            <div style={{textAlign:'center',padding:'20px 0'}}>
              <div style={{fontSize:32,marginBottom:12}}>✓</div>
              <div style={{fontWeight:700,fontSize:16,color:'var(--text)',marginBottom:8}}>Password set successfully</div>
              <div style={{fontSize:13,color:'var(--text-muted)'}}>Taking you to the portal...</div>
            </div>
          ) : (
            <>
              <p style={{fontSize:13,color:'var(--text-muted)',marginBottom:16}}>
                For security, please set a new password before continuing.
              </p>
              {policy && (
                <div style={{background:'var(--surface2)',border:'1px solid var(--border)',borderRadius:'var(--radius)',padding:'10px 14px',marginBottom:16,fontSize:12,color:'var(--text-muted)'}}>
                  <div style={{fontWeight:600,marginBottom:4,color:'var(--text)'}}>Password requirements</div>
                  <div>• At least {policy.min_length} characters</div>
                  {policy.block_common && <div>• Must not be a commonly used password</div>}
                  {policy.require_complexity && <div>• Must include uppercase, number and symbol</div>}
                </div>
              )}
              <form onSubmit={handleSubmit} className="login-form">
                <div className="login-field">
                  <label>New Password</label>
                  <input type="password" value={password} onChange={e => setPassword(e.target.value)}
                    placeholder={`Min ${policy?.min_length || 12} characters`} required autoFocus />
                </div>
                <div className="login-field">
                  <label>Confirm Password</label>
                  <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)}
                    placeholder="Repeat password" required />
                </div>
                {error && <div className="error-msg">{error}</div>}
                <button className="btn btn-primary btn-lg login-btn" type="submit" disabled={loading}>
                  {loading ? <span className="spinner" /> : 'Set Password & Continue'}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
